import React, { useState } from "react";
import { InputHelperText, useInput } from "react-admin";
import { useFormContext } from "react-hook-form";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import { SelectChangeEvent } from "@mui/material/Select";

const commonStyles = {
  form: {
    marginBottom: "20px",
    width: 256,
  },
};

export const GradePenaltyInput = (props: any) => {
  const {
    field: { value, onChange, name },
    fieldState: { error },
  } = useInput(props);
  const formContext = useFormContext();

  const defaultValue = formContext.getValues(props.source);

  // 受け取らないで保存済みの場合はnull
  const initialCanReceiveItem = defaultValue !== null;
  const [canReceiveItem, setCanReceiveItem] = useState(initialCanReceiveItem);

  const initialReducedUnitPrice = value;
  const [reducedUnitPrice, setReducedUnitPrice] = useState(initialReducedUnitPrice);

  const onChangeSwitch = (ev: SelectChangeEvent<"receive" | "not_receive">) => {
    if (ev.target.value === "receive") {
      setCanReceiveItem(true);
      onChange(reducedUnitPrice);
      formContext.trigger(name);
    } else {
      setCanReceiveItem(false);
      // 受け取らない場合は金額としてnullを設定する
      onChange(null);
    }
  };

  const onChangeText = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setReducedUnitPrice(ev.target.value);
    onChange(ev.target.value);
    formContext.trigger(name);
  };

  return (
    <>
      <div>
        <FormControl variant="filled" sx={{ ...commonStyles.form, marginBottom: "0px" }}>
          <InputLabel id="label">受け取り可否</InputLabel>
          <Select<"receive" | "not_receive">
            labelId="label"
            id="select"
            value={canReceiveItem ? "receive" : "not_receive"}
            onChange={onChangeSwitch}
          >
            <MenuItem value={"receive"}>減額して受け取る</MenuItem>
            <MenuItem value={"not_receive"}>受け取らない</MenuItem>
          </Select>
          <FormHelperText variant="filled">
            <InputHelperText helperText="ui.offers.filled_helper_text" />
          </FormHelperText>
        </FormControl>
      </div>
      {canReceiveItem && (
        <div>
          <FormControl variant="filled" sx={{ ...commonStyles.form, marginTop: "0px" }}>
            <TextField
              type="number"
              variant="filled"
              label="減額する単価"
              value={reducedUnitPrice}
              onChange={onChangeText}
            />
            {error && (
              <FormHelperText variant="filled" error>
                <InputHelperText touched={error} error={error && error.message} />
              </FormHelperText>
            )}
          </FormControl>
        </div>
      )}
    </>
  );
};
